import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement("g", { clipPath: "url(#empty-postal-box_svg__clip0_1996_76440)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M70.39 14.063C62.782.889 50.34.889 42.732 14.063L3.367 82.246c-7.606 13.174-1.382 23.952 13.828 23.952h78.732c15.21 0 21.434-10.778 13.828-23.952L70.389 14.063z",
      fill: "#FF9063"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M81.073 96.244L65.948 69.96 50.815 96.244M32.799 96.244L17.677 69.96 2.543 96.244",
      fill: "#C15742"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M122.056 96.255l-26.518-45.93c-5.123-8.875-13.508-8.875-18.63 0L50.39 96.255",
      fill: "#F86D4C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M70.793 96.306L52.001 63.76c-3.63-6.29-9.571-6.29-13.202 0L20.007 96.306",
      fill: "#F86D4C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M33.824 96.306L15.032 63.76c-3.63-6.29-9.572-6.29-13.203 0l-18.792 32.546",
      fill: "#F86D4C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M38.174 49.453a4.667 4.667 0 100-9.334 4.667 4.667 0 000 9.334z",
      fill: "#FFFBEF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M42.843 49.453a2.923 2.923 0 100-5.845 2.923 2.923 0 000 5.845z",
      fill: "#FFFBEF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M45.975 49.453a2.212 2.212 0 100-4.424 2.212 2.212 0 000 4.424zM33.507 49.453a2.212 2.212 0 100-4.423 2.212 2.212 0 000 4.423z",
      fill: "#FFFBEF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M33.507 44.786v4.667h14.68V47.24M78.752 55.19a4.667 4.667 0 100-9.334 4.667 4.667 0 000 9.334z",
      fill: "#FFFBEF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M83.419 55.188a2.923 2.923 0 100-5.846 2.923 2.923 0 000 5.846z",
      fill: "#FFFBEF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M86.55 55.188a2.212 2.212 0 100-4.424 2.212 2.212 0 000 4.423zM74.082 55.188a2.212 2.212 0 100-4.424 2.212 2.212 0 000 4.423z",
      fill: "#FFFBEF"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M74.081 50.523v4.667h14.683v-2.214", fill: "#FFFBEF" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M56.266 40.12a7.425 7.425 0 100-14.851 7.425 7.425 0 000 14.85z",
      fill: "#FDCD79"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M82.512 96.244v-1.535c0-.844.651-2.662 1.447-4.038l4.117-7.131c.796-1.376 2.096-1.376 2.892 0l4.117 7.13c.796 1.377 1.447 3.195 1.447 4.039v1.535",
      fill: "#FF9063"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M90.936 91.775h-2.888v4.469h2.888v-4.469z", fill: "#F86D4C" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.83 96.244v-1.778c0-.98.753-3.087 1.677-4.684l4.774-8.27c.923-1.597 2.433-1.597 3.353 0l4.774 8.27c.924 1.597 1.677 3.704 1.677 4.684v1.778",
      fill: "#FF9063"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M17.603 91.061h-3.35v5.183h3.35V91.06z", fill: "#F46F50" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M40.847 96.244v-.776c0-.428.328-1.345.73-2.042l2.079-3.602c.402-.697 1.059-.697 1.461 0l2.079 3.602c.402.697.73 1.614.73 2.042v.776",
      fill: "#FF9063"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M45.103 93.984h-1.459v2.257h1.459v-2.257z", fill: "#F46F50" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M103.468 79.074l-4.463 7.728h8.923l-4.46-7.728z",
      fill: "#FFFBEF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M103.468 83.563l-4.463 7.728h8.923l-4.46-7.728z",
      fill: "#FFFBEF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M103.468 88.088l-4.463 7.728h8.923l-4.46-7.728z",
      fill: "#FFFBEF"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M104.402 92.602h-1.869v5.987h1.869v-5.987z", fill: "#FFFBEF" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M101.596 86.802h3.741l.467.81h-4.675l.467-.81zM101.596 91.29h3.741l.467.808h-4.675l.467-.807z",
      fill: "#FDCD79"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M29.446 86.276l-3.042 5.27h6.083l-3.041-5.27z",
      fill: "#FFFBEF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M29.446 89.337l-3.042 5.267h6.083l-3.041-5.267z",
      fill: "#FFFBEF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M29.446 92.42l-3.042 5.271h6.083l-3.041-5.27z",
      fill: "#FFFBEF"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M30.083 95.499h-1.274v4.08h1.274V95.5z", fill: "#FFFBEF" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M28.172 91.546h2.551l.317.55h-3.185l.317-.55zM28.172 94.604h2.551l.317.552h-3.185l.317-.552zM82.719 84.735H62.794c-2.4 0-3.099-1.402-3.099-1.402-.515-.739-.441-1.693-.441-1.693v-9.985c0-7.48 6.063-13.545 13.545-13.545 7.481 0 13.544 6.063 13.544 13.545v10.257s.051 1.19-.954 1.985c-1.005.796-2.294.838-2.668.838h-.002z",
      fill: "#FDCD79"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M55.484 58.113h17.312v7.34H55.484v-7.34z", fill: "#FDCD79" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M65.408 84.735H45.483c-2.399 0-3.098-1.402-3.098-1.402-.515-.739-.442-1.693-.442-1.693v-9.985c0-7.48 6.063-13.545 13.545-13.545s13.545 6.063 13.545 13.545v10.257s.05 1.19-.955 1.985c-1.005.796-2.293.838-2.667.838h-.003z",
      fill: "#2D343A"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M69.03 82.353H30.083v2.382H69.03v-2.382z", fill: "#FDCD79" }), /* @__PURE__ */ e.createElement("path", { d: "M68.832 84.534h-5.774v21.661h5.774v-21.66z", fill: "#FDCD79" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M33.433 62.768c2.384 2.937 5.278 6.086 9.226 6.658 1.977.286 4.177-.011 5.715-1.382.631-.563 1.107-1.32 1.178-2.177.07-.859-.309-1.663-.94-2.204-1.521-1.302-3.583-.948-5.194-.022a14.077 14.077 0 00-2.43 1.798c-.697.637-1.345 1.382-1.75 2.243-.81 1.721-.456 3.565.759 4.995 1.249 1.47 3.1 2.277 4.961 2.642 2.198.433 4.455.306 6.664.029 1.886-.238 3.973-.42 5.627-1.445.39-.24.747-.532 1.062-.866.373-.4-.227-1-.6-.6-1.153 1.228-2.872 1.585-4.47 1.835-1.942.302-3.916.543-5.884.47-1.827-.068-3.732-.422-5.298-1.41-1.286-.81-2.444-2.13-2.43-3.73.014-1.725 1.34-3.096 2.602-4.104 1.286-1.03 3.016-2.226 4.752-1.75.663.181 1.317.6 1.595 1.255.277.654.082 1.413-.355 1.976-1.104 1.422-3.086 1.79-4.782 1.685-4.053-.249-7.018-3.548-9.405-6.49-.346-.425-.943.178-.6.6l-.003-.006zM51.823 78.856c.86.06 1.742-.034 2.588-.158 1.87-.278 3.69-.912 5.29-1.923.462-.292.034-1.028-.427-.734-1.544.975-3.285 1.572-5.087 1.838-.773.114-1.58.184-2.364.13-.547-.036-.544.813 0 .85v-.003zM27.976 61.392c.89 1.58 2.26 2.965 3.696 4.044a12.385 12.385 0 002.359 1.399c.21.096.456.06.58-.153.108-.181.057-.487-.153-.58-2.209-.997-4.126-2.68-5.468-4.687a6.733 6.733 0 01-.283-.453c-.27-.476-1.003-.049-.734.427l.003.003zM28.095 53.856c.053.029.088.502.102.564.096.47.223.934.38 1.388.398 1.166 1.007 2.367 2.021 3.115.448.328.963.549 1.515.628.476.068 1.419.19 1.759-.272.62-.843.153-2.073-.306-2.877a3.303 3.303 0 00-2.266-1.591c-1.152-.215-2.143-.391-3.202-.955h-.003z",
      fill: "#FFFBEF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M29.573 55.74c1.17 1.33 2.478 2.636 3.947 3.63.456.309.949.598 1.487.734.266.068.38-.343.113-.411-.994-.252-1.874-1.005-2.633-1.66a28.14 28.14 0 01-2.19-2.126 16.647 16.647 0 01-.424-.467c-.181-.207-.482.096-.3.3z",
      fill: "#FDCD79"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M27.784 71.675c.06-.012.388.331.436.37.374.3.768.581 1.175.833 1.048.649 2.283 1.192 3.54 1.124a3.341 3.341 0 001.57-.475c.41-.25 1.217-.756 1.186-1.326-.057-1.045-1.198-1.699-2.062-2.03a3.31 3.31 0 00-2.76.207c-1.029.566-1.904 1.059-3.082 1.294l-.003.003z",
      fill: "#FFFBEF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M30.084 72.187c.937.153 1.888.252 2.837.312 1.345.085 2.934.19 4.188-.397.247-.116.032-.481-.215-.368-.558.26-1.212.326-1.82.36-.745.042-1.49.02-2.235-.028-.884-.06-1.77-.15-2.645-.292-.266-.043-.382.365-.113.41l.003.003z",
      fill: "#FDCD79"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M68.832 84.735h-5.774v8.21h5.774v-8.21z", fill: "#A58B62" }), /* @__PURE__ */ e.createElement("path", { d: "M68.831 84.735h-1.104v21.463h1.104V84.735z", fill: "#2D343A" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M69.03 82.353H49.195v2.382H69.03v-2.382zM86.34 70.48H69.03v14.255h17.31V70.48z",
      fill: "#A58B62"
    }
  )),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "empty-postal-box_svg__clip0_1996_76440" }, /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h113v113H0z" })))
);
export {
  t as default
};
